import React from 'react';
import { FilterOutlined } from '@ant-design/icons';
import { METRIC_FILTER_TYPES } from '@components/metrics-panel-hz/utils/metricFilterUtils';
import { BOOLEAN_METRICS } from '@components/metrics-panel-hz/utils/metricsMapping';
import { initMetricFilter } from '@store/trends/base/actions';
import { useDispatch, useSelector } from 'react-redux';
import { IconWrapper } from './styled';
import { Tooltip } from 'antd';
import { realTimeModeOnTrendsSelector } from '@store/common/selectors';
import { isTableCompareEnabledAtom } from '@src/components/dimension-panel-hz/atoms/index';
import { useSetAtom } from 'jotai';

const buildBooleanFilter = (metric) => {
  return {
    metric,
    rule: {
      type: 'equal',
      dimension: BOOLEAN_METRICS[metric].dimension,
      value: true,
    },
    meta: {
      type: METRIC_FILTER_TYPES.boolean,
    },
  };
};

function BooleanFilter({ metric }) {
  const dispatch = useDispatch();
  const liveMode = useSelector(realTimeModeOnTrendsSelector);
  const tableCompareToggle = useSetAtom(isTableCompareEnabledAtom);

  const handleClick = () => {
    tableCompareToggle(false);
    const sf = buildBooleanFilter(metric);
    dispatch(initMetricFilter(sf));
  };

  return metric in BOOLEAN_METRICS && !liveMode ? (
    <IconWrapper>
      <Tooltip title="Filter all errors">
        <FilterOutlined onClick={handleClick} />
      </Tooltip>
    </IconWrapper>
  ) : null;
}

export default BooleanFilter;
